import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './app/App';
import { AuthProvider } from './app/AuthContext';
import './styles/global.css';
import { initAppHeight } from '@/lib/appHeight';

const rootEl = document.getElementById('root');
if (!rootEl) throw new Error('Root element missing');

initAppHeight();

createRoot(rootEl).render(
  <StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <App />
      </AuthProvider>
    </BrowserRouter>
  </StrictMode>,
);

if ('serviceWorker' in navigator && import.meta.env.PROD) {
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/sw.js')
      .then((reg) => {
        // If there's already a waiting SW (a v3 kill-switch update sitting
        // idle behind a v1/v2 shell), tell it to take over immediately so
        // the RELOAD_ONCE message fires this pageview instead of the next.
        if (reg.waiting) reg.waiting.postMessage({ type: 'SKIP_WAITING' });
        reg.addEventListener('updatefound', () => {
          const nw = reg.installing;
          if (!nw) return;
          nw.addEventListener('statechange', () => {
            if (nw.state === 'installed' && navigator.serviceWorker.controller) {
              // Old SW still controls the page; nudge the new one.
              nw.postMessage({ type: 'SKIP_WAITING' });
            }
          });
        });
      })
      .catch(() => {
        // Offline support is a nice-to-have; ignore registration failures.
      });

    // The kill-switch SW posts RELOAD_ONCE on activation. Guard against
    // reload loops via sessionStorage — we reload at most once per tab
    // session, even if multiple messages arrive.
    navigator.serviceWorker.addEventListener('message', (event) => {
      if (event.data && event.data.type === 'RELOAD_ONCE') {
        if (sessionStorage.getItem('babcocknav-sw-reloaded') === '1') return;
        sessionStorage.setItem('babcocknav-sw-reloaded', '1');
        window.location.reload();
      }
    });
  });
}
